module.exports = __webpack_public_path__ + "static/media/ios-action-icon.6260f483.svg";